import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

const content: SxProps<Theme> = () => ({
  height: '100%',
  paddingTop: '56px',
  display: 'flex',
});

const page: SxProps<Theme> = () => ({
  width: '100%',
  minWidth: 0,
  overflow: 'auto',
});

const pagePadding: SxProps<Theme> = () => ({
  padding: {
    xs: '20px',
    sm: '26px 20px 50px 20px',
    lg: '26px 100px 50px',
  },
});

const childrenn = {
  paddingBottom: '50px',
};

const sidebar = {
  position: 'fixed',
  top: '60px',
};

const children: SxProps<Theme> = (theme) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.pageBackground.main,
  width: '100%',
  minHeight: '100vh',

  '@media print': {
    '.MuiButton-root': {
      display: 'none',
    },
    button: {
      display: 'none',
    },
  },
});

const grayBackground = {
  background: '#FFFFFF',
};

/** Extra bottom padding on mobile so content isn't hidden behind the fixed bottom tab bar */
const mobilePagePadding: SxProps<Theme> = {
  paddingBottom: 'calc(56px + env(safe-area-inset-bottom, 0px) + 16px)',
};

const styles = {
  container,
  grayBackground,
  content,
  childrenn,
  children,
  page,
  pagePadding,
  mobilePagePadding,
  sidebar,
};

export default styles;
